import withProps from "recompose/withProps";


/**
 * @param type
 * @param typeCallback
 * @param callback
 * @param options
 */
export default function optionCallback(type: string, typeCallback: string, callback: any, options?: any) {
	return withProps((props: any) => {
		let _VALUES = {};
		let values = props[type] || {}

		values[typeCallback] = Object.assign(
			{name: typeCallback},
			{ callback: (v: any) => callback(v || {}),  options: options || {}}
		)
		_VALUES[type] = values;
		return _VALUES
	});
}